<script lang="ts" context="module">
  import { getAppConfig } from '../../../common/config/app-config';
  import { CONSTANTS } from '../../../common/config/constants';
  import {
    getJoodExpiredMembershipType,
    getJoodMembershipType,
    getPriceHTMLOrFree,
    getStr,
  } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import ProductTileJoodWalletCreditAmount from '../../common/components/productTile/components/ProductTileJoodWalletCreditAmount.svelte';
  import UpgradeService from './UpgradeService.svelte';

  const userJoodLevel = getJoodMembershipType();
  const { joodFullCappingLimitReached } = getAppConfig();
  const ExpireduserJoodLevel = getJoodExpiredMembershipType();
  const visible = true;
  const { NOPRIME, VIPPRIME, BASICPRIME, SMARTPRIME } = CONSTANTS;
</script>

<script lang="ts">
  export let data;
  export let active: boolean;
  export let addonView: boolean;
  export let readonly = false;
  export let joodServiceCard = null;
  export let serviceJoodCardType;
  export let hideNameField;

  const joodUserType = joodServiceCard ? joodServiceCard : userJoodLevel;
  const { productDetails, pageTemplate } = getAppConfig();

  const isUpgrade = pageTemplate === 'extraPreOrderLandingPageTemplate' && productDetails?.upgradeDisclaimerText;
  $: isNoPlan = data?.noPlanOption;
  $: displayPrice = data?.servicePrice?.value;
  $: creditPoints = getCreditPointsPrice(data, joodFullCappingLimitReached);

  const isJoodMember = joodUserType !== NOPRIME;

  function getCreditPointsPrice(data, joodFullCappingLimitReached) {
    if (joodFullCappingLimitReached === 'true') {
      // In case jood capping is reached, we don't show any credits
      return 0;
    }

    switch (userJoodLevel) {
      case NOPRIME:
        if (ExpireduserJoodLevel === BASICPRIME) return data?.basicPrimeDiscountPrice?.value;
        else if (ExpireduserJoodLevel === VIPPRIME) return data?.vipPrimeDiscountPrice?.value;
        else if (ExpireduserJoodLevel === SMARTPRIME) return data?.smartPrimeDiscountPrice?.value;
        else return data?.vipPrimeDiscountPrice?.value;
      case BASICPRIME:
        return data?.basicPrimeDiscountPrice?.value;
      case VIPPRIME:
        return data?.vipPrimeDiscountPrice?.value;
      case SMARTPRIME:
        return data?.smartPrimeDiscountPrice?.value;
    }
  }
  function getLabelHtml(vasType) {
    if (!vasType?.label) {
      vasType.label = '';
    }
    if (addonView) return getStr('extra.pdp.service.addon');
    else return `<strong>${vasType?.label}</strong>`;
  }
  function getName(vasType) {
    if (addonView) return `${getStr('extra.pdp.service.accidental.warranty.text')} (${vasType?.name})`;
    else return vasType?.name;
  }
</script>

<!-- Safeguard tile view -->
{#if visible}
  <div class="position-relative wallet-service" class:c_serviceupgrade={isUpgrade}>
    <UpgradeService />
    <button
      class="c_vas-price-tile vas-price-tile safeguard-tile user-{joodUserType} service-{serviceJoodCardType} {ExpireduserJoodLevel
        ? 'expired-user'
        : ''}"
      class:active
      class:addonView
      class:readonly
      disabled={readonly}
      on:click
      class:no-plan-tile={isNoPlan}
    >
      {#if isNoPlan}
        <section class="name">{data?.vasType?.name}</section>
      {:else}
        <section class="label">
          {@html getLabelHtml(data?.vasType)}
          {#if !hideNameField && pageTemplate === 'extraPreOrderLandingPageTemplate'}
            ({getName(data?.vasType)})
          {/if}
        </section>

        {#if !hideNameField && pageTemplate !== 'extraPreOrderLandingPageTemplate'}
          <section class="name" class:jood-member={isJoodMember}>
            {getName(data?.vasType)}
          </section>
        {/if}
        <section class="price" class:mt-8={hideNameField}>
          {#if data?.discountedPrice?.value > 0}
            <section class="savings">
              {@html getPriceHTMLOrFree(data?.discountedPrice?.value)}
            </section>
            <span class="striked-off">{displayPrice}</span>
          {:else}
            {@html getPriceHTMLOrFree(displayPrice)}
          {/if}
        </section>
        {#if creditPoints > 0}
          <ProductTileJoodWalletCreditAmount
            isTacticalFlag={false}
            {creditPoints}
            variant="pdp-services"
            priceType={serviceJoodCardType}
          />
        {/if}
      {/if}
      {#if active}
        <section class="active-icon">
          <Icon glyph="check" type="font" desktopSize={24} />
        </section>
      {/if}
    </button>
  </div>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .wallet-service {
    flex-grow: 1;
  }

  .vas-price-tile {
    position: relative;
    text-align: start;
    background-color: $primary-white;
    padding: 8px;
    border: 1px solid $secondary-gray-02;
    border-radius: 8px;
    color: $neutral-dark-01;
    flex-grow: 1;
    height: 100%;
    &.expired-user {
      .label,
      .name,
      .price {
        color: $primary-black;
      }
    }

    &.safeguard-tile {
      min-width: max-content;
      width: 100%;
      .label {
        display: flex;
        flex-direction: column;
      }
      .price {
        margin-top: 6px;
      }
    }
    &.addonView {
      flex-grow: 0;
      flex-basis: 50%;
    }
    &.no-plan-tile {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 110px;

      .name {
        margin: 0;
      }
    }
    &.readonly {
      cursor: default;
    }

    .label {
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      color: $neutral-dark-03;

      strong {
        font-size: 11px;
      }
    }
    .name {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      margin-block: 2px 8px;
    }
    .price {
      font-size: 16px;
      line-height: 18px;
      font-weight: 400;
      .striked-off {
        color: $neutral-dark-03;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        text-decoration: line-through;
      }

      &.mt-8 {
        margin-top: 8px;
      }
    }

    .savings {
      .striked-off {
        color: $neutral-dark-03;
        font-weight: 400;
        font-size: 11px;
        line-height: 14px;
        text-decoration: line-through;
      }
      .orange-text {
        color: $functional-orange;
        font-size: 12px;
        line-height: 14px;
      }
    }

    &.user-VIPPRIME,
    &.user-BASICPRIME,
    &.user-SMARTPRIME {
      padding: 8px 8px 10px;

      &:not(.addonView) .name {
        margin-block: 8px 2px;
        font-size: 12px;
        line-height: 12px;
      }
    }
    &.service-VIPCARD_BG {
      &:not(.addonView) {
        flex-grow: unset;
        /*.savings {
          .striked-off,
          .orange-text {
            color: $jood-gold-light;
          }
        }
        .active-icon {
          color: $jood-gold-light;
          :global(i) {
            background-color: transparent;
          }
        }*/
      }
    }

    &.service-BASICCARD_BG {
      &:not(.addonView) {
        flex-grow: unset;

        /*.savings {
          .striked-off,
          .orange-text {
            color: $jood-blue-light-02;
          }
        }
        .active-icon {
          color: $jood-blue-light-02;
          :global(i) {
            background-color: transparent;
          }
        }*/
      }
    }
    &.service-SMARTCARD_BG {
      &:not(.addonView) {
        flex-grow: unset;

        /*.savings {
          .striked-off,
          .orange-text {
            color: $jood-smart-light-02;
          }
        }
        .active-icon {
          color: $jood-smart-light-02;
          :global(i) {
            background-color: transparent;
          }
        }*/
      }
    }
    &.service-VIPCARD_BG_NOPLAN {
      &:not(.addonView) {
        &.no-plan-tile {
          min-width: 110px;
          /*background-size: cover;
          border: none;
          .name {
            color: $jood-gold-light;
          }
          .active-icon {
            color: $jood-gold-light;
            :global(i) {
              background-color: transparent;
            }
          }*/
        }
      }
    }
    &.service-BASICCARD_BG_NOPLAN {
      &:not(.addonView) {
        &.no-plan-tile {
          min-width: 110px;
          /* background-size: cover;
          border: none;
          .name {
            color: $jood-blue-light-02;
          }
          .active-icon {
            color: $jood-blue-light-02;
            :global(i) {
              background-color: transparent;
            }
          }*/
        }
      }
    }
    &.service-SMARTCARD_BG_NOPLAN {
      &:not(.addonView) {
        &.no-plan-tile {
          min-width: 110px;
          /*background-size: cover;
          border: none;
          .name {
            color: $jood-smart-light-02;
          }
          .active-icon {
            color: $jood-smart-light-02;
            :global(i) {
              background-color: transparent;
            }
          }*/
        }
      }
    }
  }
</style>
